<template>
  <div class="post-one-container">
    <nav-component></nav-component>
    <div class="post-page-header" :style="{ 'background-image': 'url(' + post.data.featured_image + ')' }"></div>
    <div class="post-body">
      <div class="top">
        <h2>{{ post.data.title }}</h2>
        <div class="body-container" v-html="post.data.body" ></div>
      </div>
    </div>
    <site-map></site-map>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Butter from 'buttercms'
const butter = Butter('f6039a406e6d49002ff904362926f123057b1f56')

export default {
  name: 'BlogPost',
  data () {
    return {
      loading: true,
      post: {},
    }
  },
  methods: {
    fetchPost () {
      butter.post.retrieve(this.$route.params.slug)
        .then((response) => {
          this.loading = false
          this.post = response.data
        }).catch((response) => {
          console.log(response)
        })
    },
  },
  created () {
    this.fetchPost()
  },
}
</script>

<style scoped>
  .post-one-container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .post-page-header {
    width: 100%;
    height: 700px;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  /*.post-body {
    width: 75%;
    margin: 30px auto;
    padding: 60px 60px 120px;
    text-align: left;
  }
  .top { margin-bottom: 70px; }


  .post-body .top h2 { 
    font-size: 44px; 
    font-family: adobe-caslon-pro, serif;
    font-weight: 700;
    font-style: italic;
  }
  .post-one-container p { 
    font-size: 20px; 
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .post-image img {
    width: 100%;
  }
  .credits p {
    font-size: 90%;
  }

  .credits a {
    color: #666666 !important;
  }

  ul.blog-list {
    display: flex !important;
    flex-direction: column;
    list-style-type: disc !important;
  }
  .body-container img {
      width: 100% !important;
      height: auto;
  }

  @media ( max-width: 775px ) {
    .post-body {
      padding: 20px;
      margin-bottom: -60px;
    }
    .post-body .center {
      flex-direction: column;
    }

    .post-body .center .left img { 
      width: 100%;
      margin-bottom: 60px;
    }
  }*/
</style>

<style>
  .post-body .body-container img {
    width: 80% !important;
    height: auto;
  }

  .post-body {
    width: 75%;
    margin: 30px auto;
    padding: 60px;
    text-align: left;
  }
  .top { margin-bottom: 70px; }


  .post-body .top h2 { 
    font-size: 44px; 
    font-family: adobe-caslon-pro, serif;
    font-weight: 700;
    font-style: italic;
  }
  .post-one-container p { 
    font-size: 20px; 
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .post-image img {
    width: 100%;
  }
  .credits p {
    font-size: 90%;
  }

  .credits a {
    color: #666666 !important;
  }

  ul.blog-list {
    display: flex !important;
    flex-direction: column;
    list-style-type: disc !important;
  }
  .body-container img {
      width: 100% !important;
      height: auto;
  }

  @media ( max-width: 775px ) {
    .post-body {
      padding: 20px;
      margin-bottom: -60px;
    }
    .post-body .center {
      flex-direction: column;
    }

    .post-body .body-container img { width: 100% !important; }
  }
</style>


// WEBPACK FOOTER //
// src/components/BlogPost.vue